// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ol_0","label":"styles_label__3jydo"};